<template>
  <span>
    <modal v-if="showModal && !disabled" @close="showModal=false" @confirm="cancel()">
      <slot slot="header"><h3 class="is-size-4"><slot name="title">Confirm action</slot></h3></slot>
      <slot name="body" slot="body">Are you sure?</slot>
      <div slot="footer">
        <button class="button" @click="showModal = false; $emit('close')">
          No, I'm not
        </button>
        <button class="button is-primary" @click="showModal = false; $emit('confirm')">
          Yes, I'm sure
        </button>
      </div>
    </modal>
    <span :disabled="disabled" @click="showModal = true">
      <slot name="trigger"></slot>
    </span>
  </span>
</template>

<script>
import Modal from '@/components/Modal'

export default {
  name: 'modalConfirm',
  components: {Modal},
  props: ['disabled'],
  data () {
    return {
      showModal: false
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/ModalConfirm.vue